module.exports = __webpack_public_path__ + "img/frame-login-tl.37edcfae.webp";